// Consecutive failures of the same test(s) without a pass
// High test retires, this will exclude tests/suites that have recently been x'd
// High consecutive failues on the same suite/tests, on the latest runs
// Longest duration suites/tests

import { Grid, Header, Segment, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import Duration from '../../../components/Duration';

const Container = styled.div`
	position: absolute;
	margin-top: 15px;
	height: 90%;
	overflow-y: scroll;
	overflow-x: hidden;
`;

const RightCell = styled.span`
	text-align : right;
	display : block;
`;

const Shadow = styled.div`
	box-shadow : 0 5px 15px rgb(0 0 0 / 20%);
`;

const CenterDiv = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 20px;
`;

function Dashboard() {
	const consecutive_failures = [
		{
			display : `FOCUS-12345.js`,
			value   : 4
		},
		{
			display : `FOCUS-22993.js`,
			value   : 3
		},
		{
			display : `FOCUS-98325.js`,
			value   : 3
		},
	];

	const high_fail_rate = [
		{
			display : `FOCUS-99283.js`,
			value   : 10
		},
		{
			display : `FOCUS-73328.js`,
			value   : 6
		},
		{
			display : `FOCUS-19923.js`,
			value   : 12
		},
		{
			display : `FOCUS-44383.js`,
			value   : 8
		},
		{
			display : `FOCUS-42883.js`,
			value   : 10
		},
	];

	const high_retries = [
		{
			display : `FOCUS-99283.js`,
			value   : 33
		},
		{
			display : `FOCUS-73328.js`,
			value   : 18
		},
		{
			display : `FOCUS-19923.js`,
			value   : 12
		},
		{
			display : `FOCUS-44383.js`,
			value   : 8
		},
		{
			display : `FOCUS-42883.js`,
			value   : 10
		},
	];

	const recently_added = [
		{
			display : `FOCUS-12283.js`,
			value   : `It is a long established fact that a reader will be distracted by the readable content of a page`
		},
		{
			display : `FOCUS-12283.js`,
			value   : `Contrary to popular belief, Lorem Ipsum is not simply random text`
		},
		{
			display : `FOCUS-12283.js`,
			value   : `There are many variations of passages of Lorem Ipsum available`
		},
		{
			display : `FOCUS-12283.js`,
			value   : `The standard chunk of Lorem Ipsum used since the 1500s is reproduced`
		},
	];

	const long_tests = [
		{
			display : `FOCUS-22883.js`,
			value   : <Duration duration="1002833" />
		},
		{
			display : `FOCUS-28992.js`,
			value   : <Duration duration="5002844" />
		},
		{
			display : `FOCUS-1123.js`,
			value   : <Duration duration="4992233" />
		},
		{
			display : `FOCUS-55223.js`,
			value   : <Duration duration="2299822" />
		},
	];

	const stats = [
		{
			display : `Runs`,
			value   : 153,
		},
		{
			display : `Run Passes`,
			value   : 150,
		},
		{
			display : `Run Fails`,
			value   : 3,
		},
		{
			display : `Suites`,
			value   : 2398,
		},
		{
			display : `Suite Passes`,
			value   : 2300,
		},
		{
			display : `Suite Fails`,
			value   : 98,
		},
	];

	return <CenterDiv>Dashboard coming soon</CenterDiv>

	/* eslint-disable */
	return (
		<Container>
			<Grid>
				<Grid.Row>
					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">Consecutive Suite Failures (factor in distinct failures not on the same run/branch)</Header>
							{consecutive_failures.length ? (
								<Table attached>
									<Table.Body>
										{consecutive_failures.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>

					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">High Fail Rate</Header>
							{high_fail_rate.length ? (
								<Table attached>
									<Table.Body>
										{high_fail_rate.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row>
					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">Flaky Last 24 hours</Header>
							{consecutive_failures.length ? (
								<Table attached>
									<Table.Body>
										{consecutive_failures.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>

					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">High Test Scores (FB)</Header>
							{high_fail_rate.length ? (
								<Table attached>
									<Table.Body>
										{high_fail_rate.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row>
					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">High Suite Retries</Header>
							{high_retries.length ? (
								<Table attached>
									<Table.Body>
										{high_retries.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>

					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">Recently Added Specs</Header>
							{recently_added.length ? (
								<Table attached>
									<Table.Body>
										{recently_added.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell>{stat.value}</Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row>
					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">Longest Duration Suites</Header>
							{long_tests.length ? (
								<Table attached>
									<Table.Body>
										{long_tests.map(stat => (
											<Table.Row>
												<Table.Cell>{stat.display}</Table.Cell>
												<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
											</Table.Row>
										))}
									</Table.Body>
								</Table>
							) : (
								<Segment attached>N/A</Segment>
							)}
						</Shadow>
					</Grid.Column>

					<Grid.Column width="8">
						<Shadow>
							<Header style={{ background : "rgb(59,146,222)", color : "#fff" }} as="h5" attached="top">Stats Last 24 Hours</Header>
							<Table attached>
								<Table.Body>
									{stats.map(stat => (
										<Table.Row>
											<Table.Cell>{stat.display}</Table.Cell>
											<Table.Cell><RightCell>{stat.value}</RightCell></Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						</Shadow>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Container>
	)
}

export default Dashboard;
